<!-- eslint-disable -->
<div class="sb-live-scoreboard-baseball background-baseball">
  <div class="sb-live-scoreboard-baseball--container">
    <div class="sb-live-scoreboard-baseball--header">
      <span class="sb-live-scoreboard--subtitle">{{ match?.PeriodName }}</span>
    </div>

    <div class="sb-live-scoreboard-baseball--info">
      <span class="sb-live-scoreboard--title color-light"
        >{{( match?.ParticipantHome === null || match?.ParticipantHome === undefined) ? 'null' : (match?.ParticipantHome | sportsTitleCase) }}</span
      >
      <span class="sb-live-scoreboard--title color-light"
        >{{ (match?.ParticipantAway === null || match?.ParticipantAway === undefined) ? 'null' : (match?.ParticipantAway | sportsTitleCase) }}</span
      >
    </div>

    <div class="sb-live-scoreboard-baseball--score">
      <div class="sb-live-scoreboard-baseball--column">
        <i *ngIf="match?.HomeService" class="sb-live-scoreboard--legend color-light codere-icon icon-Bat"></i>
        <i *ngIf="!match?.HomeService" class="sb-live-scoreboard--legend color-light codere-icon icon-Pitch"></i>
        <i *ngIf="!match?.HomeService" class="sb-live-scoreboard--legend color-light codere-icon icon-Bat"></i>
        <i *ngIf="match?.HomeService" class="sb-live-scoreboard--legend color-light codere-icon icon-Pitch"></i>
      </div>

      <div *ngFor="let inning of match?.Innings; let index = index" class="sb-live-scoreboard-baseball--column">
        <span
          *ngFor="let result of inning"
          [ngClass]="{ 'color-light': currentPeriod === index + 1 }"
          class="sb-live-scoreboard--number"
          >{{ result }}</span
        >
      </div>

      <div class="sb-live-scoreboard-baseball--column has-background">
        <span class="sb-live-scoreboard--number color-yellow">{{ match?.ResultHome }}</span>
        <span class="sb-live-scoreboard--number color-yellow">{{ match?.ResultAway }}</span>
      </div>
    </div>
  </div>

  <div class="sb-live-scoreboard-baseball--container has-details">
    <div class="sb-live-scoreboard-baseball--detail">
      <span class="sb-live-scoreboard--subtitle">Bases</span>
      <div class="sb-live-scoreboard-baseball--dots has-bases">
        <i
          class="sb-scoreboard-dot"
          *ngFor="let base of bases"
          [ngClass]="{
            'background-color-yellow': base,
            'background-color-white': !base
          }"
        ></i>
      </div>
    </div>

    <div class="sb-live-scoreboard-baseball--detail">
      <span class="sb-live-scoreboard--subtitle">Balls <span class="color-yellow">{{ match?.Balls }}</span></span>
      <div class="sb-live-scoreboard-baseball--dots">
        <i
          class="sb-scoreboard-dot"
          [ngClass]="match?.Balls >= 1 ? 'background-color-yellow' : 'background-color-white'"
        ></i>
        <i
          class="sb-scoreboard-dot"
          [ngClass]="match?.Balls >= 2 ? 'background-color-yellow' : 'background-color-white'"
        ></i>
        <i
          class="sb-scoreboard-dot"
          [ngClass]="match?.Balls >= 3 ? 'background-color-yellow' : 'background-color-white'"
        ></i>
        <i
          class="sb-scoreboard-dot"
          [ngClass]="match?.Balls >= 4 ? 'background-color-yellow' : 'background-color-white'"
        ></i>
      </div>
    </div>

    <div class="sb-live-scoreboard-baseball--detail">
      <span class="sb-live-scoreboard--subtitle">Strikes <span class="color-yellow">{{ match?.Strikes }}</span></span>
      <div class="sb-live-scoreboard-baseball--dots">
        <i
          class="sb-scoreboard-dot"
          [ngClass]="
            match?.Strikes >= 1
              ? 'background-color-yellow'
              : 'background-color-white'
          "
        ></i>
        <i
          class="sb-scoreboard-dot"
          [ngClass]="
            match?.Strikes >= 2
              ? 'background-color-yellow'
              : 'background-color-white'
          "
        ></i>
        <i
          class="sb-scoreboard-dot"
          [ngClass]="
            match?.Strikes >= 3
              ? 'background-color-yellow'
              : 'background-color-white'
          "
        ></i>
      </div>
    </div>

    <div class="sb-live-scoreboard-baseball--detail">
      <span class="sb-live-scoreboard--subtitle">Out <span class="color-yellow">{{ match?.Outs }}</span></span>
      <div class="sb-live-scoreboard-baseball--dots">
        <i
          class="sb-scoreboard-dot"
          [ngClass]="
            match?.Outs >= 1
              ? 'background-color-yellow'
              : 'background-color-white'
          "
        ></i>
        <i
          class="sb-scoreboard-dot"
          [ngClass]="
            match?.Outs >= 2
              ? 'background-color-yellow'
              : 'background-color-white'
          "
        ></i>
        <i
          class="sb-scoreboard-dot"
          [ngClass]="
            match?.Outs >= 3
              ? 'background-color-yellow'
              : 'background-color-white'
          "
        ></i>
      </div>
    </div>
  </div>
</div>
